import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Str from "shared/components/Str";
import FacebookLib from "shared/util/Facebook";
import { FACEBOOK_STATE_STRINGS } from "apps/signup/util/constants";

class Facebook extends Component {
	static propTypes = {
		hasError: PropTypes.bool,
		feedback: PropTypes.string,
		facebookState: PropTypes.string.isRequired,
		facebookSignup: PropTypes.func.isRequired,
	};

	componentDidMount() {
		FacebookLib.load();
	}

	render() {
		const { facebookState, facebookSignup, hasError, feedback } = this.props;
		const buttonClass = classnames({
			"signup2017-facebook-button": true,
			"signup2017-facebook-button--error": hasError,
		});

		// default back to ready state text
		const buttonText = hasError ?
			FACEBOOK_STATE_STRINGS.ready : FACEBOOK_STATE_STRINGS[facebookState];

		return (
			<div className="signup2017-facebook">
				<div
					role="button"
					tabIndex={0}
					className={buttonClass}
					onClick={facebookSignup}
				>
					<i className="okicon i-facebook signup2017-facebook-button-icon" />
					<span>{buttonText}</span>
				</div>

				{hasError &&
					<div className="signup2017-facebook-error">
						<span>{feedback}</span>
					</div>
				}

				<div className="signup2017-facebook-notice">
					<Str>We never post to Facebook</Str>
				</div>
			</div>
		);
	}
}

export default Facebook;



// WEBPACK FOOTER //
// ./src/apps/signup/components/EmailOrFb/Facebook.jsx